import { gql } from "@apollo/client";

export const CHECK_DOCUMENT_EXISTS = gql`
  query CheckDocumentExists($reference: String!) {
    documentExists(reference: $reference) {
      id
    }
  }
`; 